/**
 * @constructor
 * @param { Object } params
 * @param { String } params.startWord - Word to start the list with.
 * @param { String } params.itemsSeparators - Word to separate the different resources.
 */
export function DisplayConfig(params = {}) {
  this.startWord = params.startWord || '';
  this.itemsSeparators = params.itemsSeparators || ',';
}

/**
 * Creates a valid prop for UserGroupItemSummary
 * @constructor
 * @param { Object } params
 * @param { Function(String[] | ItemSummary[]): Boolean } params.areThereResources -
 * Function to indicate if there are resources
 * @param { String } params.fallbackLinkText - Link (Text) to show if there aren't resources
 * @param { String } params.fallbackLinkUrl - Link to show if there aren't resources
 * @param { String } params.fallbackMessage - Text to show if there aren't resources
 * @param { String[] | ItemSummary[] } params.items - Resources to show,
 * should only be a array of ItemSummaries if the component being used is
 * UserGroupMultipleItemsSummary.
 * @param { Boolean } params.openLinkInNewTab - Wether the link is open in a new tab or not
 * @param { String } params.title - Title to show at the top
 * @param { Boolean } params.wasDataFetched = true] - Property to show loader if is false
 * @param { String } params.iconLocation - Property to get the img to show,
 * this property is only used in UserGroupMultipleItemsSummary component
 * @param { DisplayConfig } params.displayConfig - Configuration to show items,
 */
export default function ItemSummary(params = {}) {
  this.iconLocation = params.iconLocation || '';
  this.areThereResources = params.areThereResources || (items => items.length);
  this.fallbackLinkText = params.fallbackLinkText || '';
  this.fallbackLinkUrl = params.fallbackLinkUrl || '';
  this.fallbackMessage = params.fallbackMessage || '';
  this.items = params.items || [];
  this.subItems = params.subItems || [];
  this.openLinkInNewTab = params.openLinkInNewTab || false;
  this.title = params.title || '';
  this.wasDataFetched = typeof params.wasDataFetched === 'undefined' ? true : params.wasDataFetched;
  this.displayConfig = params.displayConfig || new DisplayConfig();
}
